type DiffResult<T> = {
  first: Partial<T>;
  second: Partial<T>;
};

/**
 * 2つのオブジェクトの差分を取り出す関数
 * @param obj1 - 一つ目のオブジェクト
 * @param obj2 - 二つ目のオブジェクト
 * @returns - 差分(2つ目のオブジェクトの内容)
 */
export const objectDiff = <T extends object>(obj1: T, obj2: T): DiffResult<T> => {
  /**
   * 与えられた引数がobjectであることを保証する
   * @param value - なんらかの値
   */
  const isPlainObject = (value: unknown): value is object => {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  };
  const diffFirst: Partial<T> = {};
  const diffSecond: Partial<T> = {};

  for (const key in obj2) {
    if (!obj2.hasOwnProperty(key)) continue;

    const val1 = obj1[key];
    const val2 = obj2[key];

    if (
      typeof val1 === 'object' &&
      typeof val2 === 'object' &&
      val1 !== null &&
      val2 !== null &&
      !Array.isArray(val1) &&
      !Array.isArray(val2)
    ) {
      let nestedDiff: DiffResult<T[Extract<keyof T, string>]> = { first: {}, second: {} };
      if (isPlainObject(val1) && isPlainObject(val2)) {
        nestedDiff = objectDiff(val1, val2);
      }
      if (Object.keys(nestedDiff.first).length > 0 || Object.keys(nestedDiff.second).length > 0) {
        (diffFirst as any)[key] = nestedDiff.first;
        (diffSecond as any)[key] = nestedDiff.second;
      }
    } else if (val1 !== val2) {
      diffFirst[key] = val1;
      diffSecond[key] = val2;
    }
  }

  return {
    first: diffFirst,
    second: diffSecond,
  };
};
